const ynConf = {
  clientBaseUrl: window.location.origin,
  apiBaseUrl: '/api/v1',
  fileBaseUrl: 'http://localhost:3002/files/v1',
  wsUrl: `ws://localhost:8080/web`,
  wsGuestUrl: `ws://localhost:8083/guest`,
  recCallBaseUrl: 'https://web.youneed.it/reccall/',
  publicFolderPath: '',
  youtubeKey: 'AIzaSyC2J9iDNqf7Lepd8G8oXzcuSPJbw188rRI',
  googleKey: 'AIzaSyDlsG83ErItAKC0xR2cafuVdge9_ODbYvg',
  screenSharingExtensionUrl:
    'https://chrome.google.com/webstore/detail/youneed-screensharing/hmkcpajkidhbjcjfpnohokkhgdmfecpl?hl=en-US&gl=IT&authuser=1',
  openweather: {
    baseUrl: 'https://api.openweathermap.org',
    path: '/data/2.5/forecast?mode=json&units=metric',
    appid: 'fae22bc00ba45d3c246870e04076a610',
  },
  paypalClientId:
    'AUdVk4mnbn3xJ9JrzsiRPOGpyZSoCEtXaQtjS-4Ol0NF9ICDKDghAWGRsgVJOEHeGIearqlODObH8cYg',
  jitsi: {
    appId: 'vpaas-magic-cookie-dcc20de6069d4b1793c0803418f9e248',
  },
};
export default ynConf;
